import React from 'react'
import { Tooltip } from 'antd'
import { IconInfo } from '@edulastic/icons'
import InputTag from './SearchTag'
import { SearchWrapper } from '../Container/styled'

/**
 * Reusable search input component with tooltip
 * Used across ItemList and AddItems components for consistent search UI
 */
const SearchInputWithTooltip = ({
  placeholder = 'Search by question phrase or topic. Use the left filters to narrow by Standard, Tags, etc.',
  tooltipTitle = 'Enter a phrase or topic to find questions. Use the left filters to narrow your search by Standard (e.g., 8.EE.A.1). To find questions by specific tests or keywords (e.g., LEAP, photosynthesis), use the Tags filter.',
  onSearchInputChange,
  value = [],
  disabled = false,
}) => (
  <SearchWrapper>
    <InputTag
      placeholder={placeholder}
      onSearchInputChange={onSearchInputChange}
      value={value}
      disabled={disabled}
    />
    <Tooltip title={tooltipTitle} placement="left">
      <IconInfo width={20} height={20} style={{ marginLeft: '10px' }} />
    </Tooltip>
  </SearchWrapper>
)

export default SearchInputWithTooltip
